import { render, staticRenderFns } from "./SfBreadcrumbs.vue?vue&type=template&id=28be8cb2&functional=true&"
import script from "./SfBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./SfBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./SfBreadcrumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports